module.exports = __webpack_public_path__ + "static/media/61.b9cb53a7.jpg";